import { render, staticRenderFns } from "./EditBtns.vue?vue&type=template&id=5ca403b2&scoped=true"
import script from "./EditBtns.vue?vue&type=script&lang=js"
export * from "./EditBtns.vue?vue&type=script&lang=js"
import style0 from "./EditBtns.vue?vue&type=style&index=0&id=5ca403b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_cache-loader@4.1.0_webpack@4.47.0__css-load_cfdd2489bf990e13646c46f5f616f51f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca403b2",
  null
  
)

export default component.exports